import React from 'react';

function Process() {
  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'Tell us about your business, goals, and vision. We\'ll discuss features, timeline, and provide a custom quote.',
      icon: '💬',
      duration: '30 min'
    },
    {
      number: '02',
      title: 'Design & Planning',
      description: 'We create mockups and wireframes for your approval. You\'ll see exactly how your site will look before we code.',
      icon: '🎨',
      duration: '3-5 days'
    },
    {
      number: '03',
      title: 'Development',
      description: 'Our expert developers build your website with clean code, optimal performance, and mobile responsiveness.',
      icon: '⚙️',
      duration: '1-2 weeks'
    },
    {
      number: '04',
      title: 'Review & Revisions',
      description: 'You review the website and request any changes. We offer unlimited revisions until you\'re 100% satisfied.',
      icon: '🔍',
      duration: '2-3 days'
    },
    {
      number: '05',
      title: 'Launch & Training',
      description: 'We launch your site, set up analytics, and provide training so you can manage it confidently.',
      icon: '🚀',
      duration: '1 day'
    },
    {
      number: '06',
      title: 'Ongoing Support',
      description: 'Enjoy free support (30 days to 1 year). We\'re here to help with updates, questions, and technical issues.',
      icon: '🛟',
      duration: 'Always'
    }
  ];

  return (
    <section className="process">
      <div className="process-container">
        <div className="process-header">
          <div className="section-label">HOW IT WORKS</div>
          <h2 className="process-title">Simple 6-Step Process</h2>
          <p className="process-subtitle">
            From concept to launch, we make it easy and stress-free
          </p>
        </div>

        <div className="process-timeline">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                {/*<div className="step-duration">⏱️ {step.duration}</div>*/}
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>

        <div className="process-cta">
          <h3>Ready to Get Started?</h3>
          <p>Let's bring your vision to life. Book a free consultation today!</p>
          <div className="process-cta-buttons">
            <a href="#contact" className="process-btn primary">
              Start Your Project →
            </a>
            <a href="#contact" className="process-btn secondary">
              📞 Call for Quick Chat
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
